var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { CommodityCodeFilter } from "./CommodityCodeFilter";
import { AmountRange } from "./../../AmountRange";
export class Filter {
  constructor(_data) {
    /**
     */
    __publicField(this, "CommodityCodes");
    /**
     */
    __publicField(this, "ItemIdentifiers");
    /**
     */
    __publicField(this, "Price");
    /**
     */
    __publicField(this, "SellerEntityId");
    /**
     */
    __publicField(this, "ShowOnlyMissing");
    /**
     */
    __publicField(this, "Sku");
    /**
     */
    __publicField(this, "Type");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof Filter
     */
    __publicField(this, "$type", "V1.ComplianceMasterData.SearchSku.Filter");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["CommodityCodes"] && _data["CommodityCodes"].constructor === Array) {
        this.CommodityCodes = [];
        for (let item of _data["CommodityCodes"]) {
          const commodityCodes_ = new CommodityCodeFilter();
          this.CommodityCodes.push(commodityCodes_.init(item));
        }
      }
      if (_data["ItemIdentifiers"] && _data["ItemIdentifiers"].constructor === Array) {
        this.ItemIdentifiers = [];
        for (let item of _data["ItemIdentifiers"]) {
          this.ItemIdentifiers.push(item);
        }
      }
      if (_data["Price"]) {
        const price_ = new AmountRange();
        this.Price = price_.init(_data["Price"]);
      }
      this.SellerEntityId = _data["SellerEntityId"];
      this.ShowOnlyMissing = _data["ShowOnlyMissing"];
      this.Sku = _data["Sku"];
      this.Type = FilterType[_data["Type"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    if (this.CommodityCodes && this.CommodityCodes.constructor === Array) {
      _data["CommodityCodes"] = [];
      for (let item of this.CommodityCodes) {
        _data["CommodityCodes"].push(item.toJSON());
      }
    }
    if (this.ItemIdentifiers && this.ItemIdentifiers.constructor === Array) {
      _data["ItemIdentifiers"] = [];
      for (let item of this.ItemIdentifiers) {
        _data["ItemIdentifiers"].push(item);
      }
    }
    _data["Price"] = this.Price ? this.Price.toJSON() : void 0;
    _data["SellerEntityId"] = this.SellerEntityId;
    _data["ShowOnlyMissing"] = this.ShowOnlyMissing;
    _data["Sku"] = this.Sku;
    _data["Type"] = FilterType[this.Type];
    return _data;
  }
}
export var FilterType = /* @__PURE__ */ ((FilterType2) => {
  FilterType2["Amazon"] = "Amazon";
  FilterType2["Custom"] = "Custom";
  return FilterType2;
})(FilterType || {});
